/** 可点击协议链接展示文案：去掉书名号（与登录页一致，接口 name 可能带《》） */
export function agreementLinkLabel(name: string | undefined | null, fallback: string): string {
  const raw = (String(name ?? '').trim() || fallback).trim();
  return raw.replace(/《|》/g, '');
}
